import { type z } from 'zod';

import { UuidSchema } from '../../common/id/id';
import { makeListQuery } from '../../common/list-query/list-query';
import { TestAttemptStatusSchema } from '../test-attempt-status/test-attempt-status';

/**
 * The attempts viewer's filters (N7) — the surface a support question is
 * answered from: "why has this member not got their discount?".
 *
 * No `search`: an attempt has no text of its own, and searching the member would
 * duplicate the members list rather than improve this one.
 */
export const TestAttemptsListQuerySchema = makeListQuery({
  testId: UuidSchema.optional(),
  userId: UuidSchema.optional(),
  status: TestAttemptStatusSchema.optional(),
});

export type TestAttemptsListQuery = z.infer<typeof TestAttemptsListQuerySchema>;
